;(() => {
  const interiorDesignersTemplate = document.querySelector(
    'section.interior-designers'
  )

  if (interiorDesignersTemplate) {
    const ITEMS_TO_REVEAL = 3
    const loadMore = document.querySelector(
      'section.interior-designers button#load-more-interior-designers'
    )

    const intialLoadHiddenItems = document.querySelectorAll(
      'section.interior-designers .article-card[hidden]'
    )

    if (intialLoadHiddenItems.length) {
      loadMore.hidden = false
    }

    loadMore?.addEventListener('click', function () {
      const hiddenItems = [
        ...document.querySelectorAll(
          'section.interior-designers .article-card[hidden]'
        )
      ].slice(0, ITEMS_TO_REVEAL)

      hiddenItems.forEach((item) => (item.hidden = false))

      if (hiddenItems.length <= ITEMS_TO_REVEAL) {
        loadMore.hidden = true
      }
    })
  }
})()
